// Where the per-session legal acknowledgement is recorded.
//
// ⚠ sessionStorage is per TAB, and a chart link opens a new tab with an empty one, so a
// signed-in user who had just acknowledged was asked again on every link they followed.
// The session cookie below has no expiry, so it is shared across this browser's tabs and
// ends with the browser session. Only a tab opened on a chart link honours it: a plain new
// tab still asks, exactly as it always has.

const ACK_KEY = "qs_acknowledged";

export function recordAcknowledged() {
  sessionStorage.setItem(ACK_KEY, Date.now().toString());
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${ACK_KEY}=1; Path=/; SameSite=Lax${secure}`;
}

export function isAcknowledged(openedOnLink) {
  if (sessionStorage.getItem(ACK_KEY)) return true;
  return !!openedOnLink && document.cookie.split("; ").some((c) => c.startsWith(`${ACK_KEY}=`));
}

export function clearAcknowledged() {
  sessionStorage.removeItem(ACK_KEY);
  document.cookie = `${ACK_KEY}=; Path=/; Max-Age=0; SameSite=Lax`;
}
